// icon
import { IoChatbubbleEllipsesSharp } from "react-icons/io5";
import { AiFillCalculator } from "react-icons/ai";
import { GrLinkTop } from "react-icons/gr";

export const quickMenuConst = [
  {
    title: "문의하기",
    link: "/partnership-inquiry",
    icon: <IoChatbubbleEllipsesSharp style={{ fontSize: "23px" }} />,
  },
  {
    title: "요금 계산기",
    link: "/billing-plan-calc",
    icon: <AiFillCalculator style={{ fontSize: "25px" }} />,
  },
  {
    title: "TOP",
    link: "#",
    icon: <GrLinkTop style={{ fontSize: "20px" }} />,
  },
];
